import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const PayPalForm = ({ enabled, t }) => {
	return (
		<div>
			<Field name='apiUsername' component={Input} required type='text' label={t('PayPal_ApiUsername')} validate={enabled && validators.required} trimOnBlur />
			<Field name='apiPassword' component={Input} required type='text' label={t('PayPal_ApiPassword')} validate={enabled && validators.required} trimOnBlur />
			<Field name='apiSignature' component={Input} required type='text' label={t('PayPal_ApiSignature')} validate={enabled && validators.required} trimOnBlur />
			<Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
			<Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
			<Field name='useSandbox' component={Checkbox} label={t('PayPal_UseSandbox')} help={t('PaymentMethod_UseSandbox_HelpText')} normalize={(v) => !!v} />
		</div>
	);
};


export default PayPalForm;